import React, {Component} from "react";
import { Col, Container, Row } from "react-bootstrap";
import { withRouter } from "../utils/withRouter";
import TicketsProducts from "../models/product-model";
import TicketBox from "../components/ticketBox";
import CommonService from "../services/common.service";
import configData from "../config.json";
import userEventService from "../services/user-event.service";

let common = new CommonService();

interface TicketsPageState {
    count: number;
    selectedDate?: Date;
    productId: string;
    productsList?: Array<TicketsProducts>;
    translations: Record<string, any>;
}

interface TicketsPageProps {
    params: {
        id: string;
    };
}

class TicketsPage extends Component<TicketsPageProps, TicketsPageState, TicketsProducts> {
    constructor(props: TicketsPageProps) {
        super(props);
        const prodID = this.props.params.id;
        const translations = JSON.parse(localStorage.getItem('translations') || '[]');
        console.log('Translations in TicketsPage constructor: ', translations);
        this.state = {
            count: 0,
            selectedDate: new Date(),
            productId: prodID ? prodID : '',
            productsList: [],
            translations: translations
        };
    }

    componentDidMount() {
        userEventService.sendEvent('page_view', 'tickets_page_open', { productId: this.state.productId });
        common.getProducts(this.state.productId).then(products => {
            if (products && products.length > 0) {
                let prodsList: any = [];
                products.forEach((element: any) => {
                    if (element.items) {
                        const images = element.images.map((kep: any) => configData.PATH + kep.image_content);
                        const subprods = element.items.map((item: any) => (
                            {
                                id: item.id, 
                                label: item.name, 
                                date: '', 
                                time: '', 
                                price_huf: item.price, 
                                price_eur: 0
                            }
                        ));
                        const prodItem = {
                            category: element.parent_prods,
                            products: [
                                {
                                    id: element.box_id, 
                                    name: element.box_title,
                                    label: element.box_title,
                                    description: element.box_subtitle,
                                    date: element.box_date.substring(0, 10), 
                                    time: element.box_date.slice(-5), 
                                    price_eur: 0, 
                                    price_huf: element.items[0].price, 
                                    available: 0, 
                                    images: images,
                                    subProducts: subprods
                                }
                            ]
                        };
                        
                        prodsList.push(prodItem);
                    }
                });
                this.setState({ productsList: prodsList });
            }
        });
    }

    increment = () => {
        this.setState({ count: this.state.count + 1 });
    }

    render() {
        return (
            <Container key={'products'} className="oc-products">
                { this.state.productsList?.map((item, index) => (
                <>
                    <Row key={'category_'+index} className="oc-page-title">
                        <Col key={'title_'+index} lg={12} md={12} sm={12} xs={12}>
                            <h2>{this.state.translations.filter((elem: any) => elem.setting_name === item.category)[0]?.setting_value_text || ''}</h2>
                        </Col>
                    </Row>
                    <Row key={'products_'+index} className="oc-page-content">
                        <Col key={'prods_'+index} lg={12} md={12} sm={12} xs={12}>
                            { item?.products.map((product, index2) => (
                                <TicketBox key={'ticket_'+index2} productData={product}></TicketBox>
                            ))}
                        </Col>
                    </Row>
                </>
                )) }
            </Container>
        );
    }
}

export default withRouter(TicketsPage);